import { render, staticRenderFns } from "./IconTooltipButtonBottom.vue?vue&type=template&id=d36f485e"
import script from "./IconTooltipButtonBottom.vue?vue&type=script&lang=js"
export * from "./IconTooltipButtonBottom.vue?vue&type=script&lang=js"
import style0 from "./IconTooltipButtonBottom.vue?vue&type=style&index=0&id=d36f485e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports